module.exports = __webpack_public_path__ + "img/avatar.dabf7830.png";